import {
  AppBar,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Paper,
  Toolbar,
  Tooltip,
  alpha,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import {
  DarkMode as DarkModeIcon,
  LightMode as LightModeIcon,
  MoreHoriz as MoreHorizIcon,
  Search as SearchIcon,
} from "@mui/icons-material";

function Header({
  search,
  onSearchChange,
  setShowProgressDialog,
  mode,
  onToggleColorMode,
}: {
  search: string;
  onSearchChange: (newSearch: string) => void;
  setShowProgressDialog: (show: boolean) => void;
  mode: "light" | "dark";
  onToggleColorMode: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const theme = useTheme();

  return (
    <AppBar
      position="static"
      color="transparent"
      sx={{
        px: { xs: 2, md: 3 },
        py: { xs: 1.5, md: 2 },
      }}
    >
      <Toolbar disableGutters sx={{ gap: 1.5 }}>
        <Paper
          elevation={0}
          sx={{
            display: "flex",
            alignItems: "center",
            flexGrow: 1,
            px: 2,
            py: 0.75,
            borderRadius: "999px",
            backgroundColor: alpha(
              mode === "dark"
                ? theme.palette.background.paper
                : theme.palette.common.white,
              mode === "dark" ? 0.6 : 0.85
            ),
            border: `1px solid ${alpha(theme.palette.divider, 0.6)}`,
            boxShadow:
              mode === "dark"
                ? "0 10px 30px rgba(0, 0, 0, 0.35)"
                : "0 12px 40px rgba(103, 80, 164, 0.12)",
            transition: theme.transitions.create([
              "box-shadow",
              "background-color",
              "border-color",
            ]),
          }}
        >
          <SearchIcon color="primary" sx={{ mr: 1 }} />
          <InputBase
            size="small"
            fullWidth
            placeholder="Buscar archivos"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            sx={{
              color: theme.palette.text.primary,
              "& .MuiInputBase-input::placeholder": {
                color: alpha(theme.palette.text.primary, 0.65),
              },
            }}
            inputProps={{ "aria-label": "Buscar en tus archivos" }}
          />
        </Paper>
        <Tooltip
          title={
            mode === "dark" ? "Cambiar a modo claro" : "Cambiar a modo oscuro"
          }
        >
          <IconButton color="primary" onClick={onToggleColorMode}>
            {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
          </IconButton>
        </Tooltip>
        <Tooltip title="Más opciones">
          <IconButton
            aria-label="Más acciones"
            color="primary"
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            <MoreHorizIcon />
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          PaperProps={{
            sx: {
              minWidth: 200,
              py: 1,
            },
          }}
        >
          <MenuItem disabled>Ver como</MenuItem>
          <MenuItem disabled>Ordenar por</MenuItem>
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              setShowProgressDialog(true);
            }}
          >
            Progreso de transferencias
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
